import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import LocalizacionAlertModal from '../LocalizacionAlertModal';

export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Navbar />
            <main className="flex-1 overflow-auto">
                <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-8 pt-7 pb-20">
                    <Outlet />
                </div>
            </main>
            {/* Vigía global: modal cuando un agente activa su localización. */}
            <LocalizacionAlertModal />
        </div>
    );
}
